$(function(){

    var landingPageInit = function(){
        if($('body').hasClass('template-suffix-gfg') || location.pathname == '/pages/getfuckedbythegovernment' ){
            landingPageGfg();
        }
    }
    
    var landingPageGfg = function(){
        console.log('landingPageGfg');
        
        if(navigator.share !== undefined){
            $('.image-share').on('click', async function(e) {
                console.log('click in share button', $(this).attr('href'));
                e.preventDefault();
    
                const response = await fetch( $(this).attr('href') );
                const blob = await response.blob();
                const filesArray = [
                    new File(
                      [blob],
                      `${$(this).data('file-name')}.png`,
                      {
                        type: blob.type
                      }
                   )
                  ];
                
                console.log( 'filesArray', filesArray);
    
                const dataToShare = {
                    title: 'Spread the outrage!',
                    files: filesArray,
                    // url: $(this).attr('href')
                }
    
                // console.log('dataToShare', dataToShare);
                // alert( navigator.canShare( dataToShare ) )
    
                if (navigator.share) {
                    await navigator.share( dataToShare ).then(() => {
                        alert('Thanks for sharing!');
                      })
                    .catch(console.error);
                } else {
                  // fallback
                }
            });
        }else{
            $('.image-share').fadeOut()
            $('.image-actions').addClass('full-w');
        }

        // Product info
        $('.product-gallery-main').slick({
            dots: true,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            arrows: true,
            // centerPadding: '20px',
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        dots: false
                    },
                }
            ]
        });

        $('.image-thumb').click(function(e){
            e.preventDefault();
            const $curr = $(this);
            let index = $curr.data('index') - 1;

            $curr.siblings('.active').removeClass('active');
            $curr.addClass('active');
            $('.product-gallery-main').slick('slickGoTo', index);
        });

        $('.price-info-box .close-box').click(function(){  $('.price-info-box').removeClass('active') });
        $('.info-box-trigger').click(function(){  $('.price-info-box').toggleClass('active') });

    }

    landingPageInit();
    
});